module.exports = __webpack_public_path__ + "media/images/payments/switch-32286f8cb1440b454a1b3ed5d60de480.svg";